module.exports = __webpack_public_path__ + "img/step2_1.9b103878.jpg";